import { getFlowFlowGet } from "../../shared/api/services.gen.js";
import { ErrorStatusCode } from "../../shared/config/errors.js";
import { createAppAsyncThunk } from "../../shared/lib/store/createAppAsyncThunk.js";
import { isErrorStatusCode } from "../../shared/lib/utils/isErrorStatusCode.js";
import ApiService from "../../shared/services/ApiService.js";
import { stagesActions } from "./reducer.js";
const getStages = createAppAsyncThunk("stages/getStages", async (_, thunkAPI) => {
  try {
    const state = thunkAPI.getState();
    const { clientId } = state.config;
    const apiClient = ApiService.getInstance().client;
    const { data: flowSchema } = await getFlowFlowGet({
      client: apiClient,
      headers: {
        "X-Client-Id": clientId
      }
    });
    if (!flowSchema || !flowSchema.stages || !flowSchema.forms) {
      throw new Error(ErrorStatusCode.STAGES_GET_STAGES_FAILED_GET_STAGES);
    }
    thunkAPI.dispatch(stagesActions.setService(flowSchema.service_info));
    return flowSchema.stages.map((stage) => {
      var _a;
      const form = (_a = flowSchema.forms) == null ? void 0 : _a.find((form2) => form2.id === stage.form);
      return {
        ...stage,
        form
      };
    }).filter((stage) => !!stage.form);
  } catch (error) {
    const statusCode = error instanceof Error && isErrorStatusCode(error.message) ? error.message : ErrorStatusCode.STAGES_GET_STAGES_DEFAULT;
    throw thunkAPI.rejectWithValue({
      statusCode
    });
  }
});
export {
  getStages
};
